"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const IdCard = _ref => {
  let {
    spotColor = "#E4EDFE",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 36"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M17.353 3.299c-3.266.85-8.454 2.287-12.234 6.562C1.338 14.149-1.38 21.67.746 25.985c2.137 4.3 9.118 5.378 15.266 7.104 6.159 1.738 11.474 4.123 15.189 2.194 3.704-1.928 5.786-8.157 6.893-13.523 1.118-5.366 1.238-9.857.153-13.612-1.073-3.755-3.375-6.761-5.994-7.751-2.63-.977-5.59.05-7.923.913-2.335.863-3.7 1.126-6.977 1.989Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "nonzero",
    d: "M38.364 30.552H7.116c-.616 0-1.116-.5-1.116-1.116V7.116C6 6.5 6.5 6 7.116 6h31.248c.616 0 1.116.5 1.116 1.116v22.32c0 .616-.5 1.116-1.116 1.116ZM8.232 28.32h29.016V8.232H8.232V28.32Zm7.812-11.16a3.348 3.348 0 1 1 0-6.696 3.348 3.348 0 0 1 0 6.696Zm0-4.464a1.116 1.116 0 1 0 0 2.232 1.116 1.116 0 0 0 0-2.232Zm4.464 13.392H11.58c-.616 0-1.116-.5-1.116-1.116V22.74a4.464 4.464 0 0 1 4.464-4.464h2.232a4.464 4.464 0 0 1 4.464 4.464v2.232c0 .616-.5 1.116-1.116 1.116Zm-7.812-2.232h6.696V22.74c0-1.233-1-2.232-2.232-2.232h-2.232c-1.233 0-2.232 1-2.232 2.232v1.116Zm22.32-7.812c0-.616-.5-1.116-1.116-1.116h-8.928a1.116 1.116 0 0 0 0 2.232H33.9c.616 0 1.116-.5 1.116-1.116Zm-2.232 4.464c0-.616-.5-1.116-1.116-1.116h-6.696a1.116 1.116 0 0 0 0 2.232h6.696c.616 0 1.116-.5 1.116-1.116Z"
  })));
};
exports.IdCard = IdCard;
IdCard.displayName = "IdCard";